import { createContext, useContext, useMemo, ReactNode } from 'react';

import { AttachmentManagementService } from '../services/AttachmentManagementService';
import { useMplServiceClient } from './MplServiceClientContext';

const AttachmentManagementServiceContext = createContext<AttachmentManagementService | undefined>(
  undefined,
);

export { AttachmentManagementServiceContext };

export function AttachmentManagementServiceProvider({ children }: { children: ReactNode }) {
  const mpl = useMplServiceClient();
  const service = useMemo(() => new AttachmentManagementService(mpl), [mpl]);
  return (
    <AttachmentManagementServiceContext.Provider value={service}>
      {children}
    </AttachmentManagementServiceContext.Provider>
  );
}

export function useAttachmentManagementService(): AttachmentManagementService {
  const context = useContext(AttachmentManagementServiceContext);
  if (!context) {
    throw new Error(
      'useAttachmentManagementService must be used within AttachmentManagementServiceProvider',
    );
  }
  return context;
}
